// extracted by mini-css-extract-plugin
export var compactFilters = "_cn-4";
export var detailImage = "_cn-1";
export var dropdownContainer = "_cn-2";
export var imageContainer = "_cn-0";
export var selectedCard = "_cn-3";